/* BDS: Cart page Save & Get Help — cart-save-help.js
   Button opens a modal form; on submit builds a mailto to the shared inbox. */

// SIWS CUSTOM: Edit Bundle Order — event delegation handles button injected by Liquid/JS.
document.addEventListener('click', function (e) {
  if (e.target && e.target.id === 'cart-edit-order-btn') {
    e.preventDefault();
    if (confirm(
      'This will clear your cart and return you to the bundle page. Continue?'
    )) {
      const bundleUrl = e.target.dataset.bundleUrl || '/';
      fetch('/cart/clear.js', { method: 'POST' })
        .then(() => { window.location.href = bundleUrl; })
        .catch(() => { window.location.href = bundleUrl; });
    }
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const btn = document.getElementById('cart-save-help-btn');
  if (!btn) return;

  // BDS: Inject modal into body once on page load.
  const modal = document.createElement('div');
  modal.id = 'bds-help-modal';
  modal.style.cssText = [
    'display:none',
    'position:fixed',
    'inset:0',
    'background:rgba(0,0,0,0.5)',
    'z-index:9999',
    'align-items:center',
    'justify-content:center',
    'padding:24px',
    'box-sizing:border-box',
  ].join(';');

  modal.innerHTML = [
    '<div style="background:#fff;max-width:480px;width:100%;padding:32px;border-radius:16px;',
    'max-height:90vh;overflow-y:auto;box-sizing:border-box;">',

    '<h2 style="margin:0 0 24px;font-size:1.25rem;font-weight:700;line-height:1.3;">',
    'Get Help from Backdoor Swag</h2>',

    '<div style="margin-bottom:16px;">',
    '<label style="display:block;font-size:0.875em;font-weight:600;margin-bottom:6px;">',
    'Name <span style="color:#dc2626;">*</span></label>',
    '<input id="bds-help-name" type="text" placeholder="Your name"',
    ' style="width:100%;box-sizing:border-box;border:1px solid #d1d5db;',
    'border-radius:8px;padding:10px 12px;font-size:1em;"></div>',

    '<div style="margin-bottom:16px;">',
    '<label style="display:block;font-size:0.875em;font-weight:600;margin-bottom:6px;">',
    'Phone Number <span style="color:#dc2626;">*</span></label>',
    '<input id="bds-help-phone" type="text" placeholder="Your phone number"',
    ' style="width:100%;box-sizing:border-box;border:1px solid #d1d5db;',
    'border-radius:8px;padding:10px 12px;font-size:1em;"></div>',

    '<div style="margin-bottom:16px;">',
    '<label style="display:block;font-size:0.875em;font-weight:600;margin-bottom:6px;">',
    'Email <span style="color:#dc2626;">*</span></label>',
    '<input id="bds-help-email" type="email" placeholder="you@example.com"',
    ' style="width:100%;box-sizing:border-box;border:1px solid #d1d5db;',
    'border-radius:8px;padding:10px 12px;font-size:1em;"></div>',

    '<div style="margin-bottom:24px;">',
    '<label style="display:block;font-size:0.875em;font-weight:600;margin-bottom:6px;">',
    'Message</label>',
    '<textarea id="bds-help-message" rows="4"',
    ' placeholder="What can we help you with?"',
    ' style="width:100%;box-sizing:border-box;border:1px solid #d1d5db;',
    'border-radius:8px;padding:10px 12px;font-size:1em;resize:vertical;"></textarea></div>',

    '<p id="bds-help-error"',
    ' style="display:none;color:#dc2626;font-size:0.875em;margin:0 0 12px;">',
    'Please fill in Name, Phone, and Email.</p>',

    '<button id="bds-help-submit" type="button"',
    ' style="width:100%;padding:14px;background:#111;color:#fff;border:none;',
    'border-radius:8px;font-size:1em;font-weight:600;cursor:pointer;margin-bottom:12px;">',
    'Send Help Request</button>',

    '<div style="text-align:center;">',
    '<a id="bds-help-cancel" href="#"',
    ' style="color:#6b7280;font-size:0.875em;text-decoration:none;">Cancel</a></div>',

    '</div>',
  ].join('');

  document.body.appendChild(modal);

  // --- helpers ---

  function openModal() {
    document.getElementById('bds-help-error').style.display = 'none';
    modal.style.display = 'flex';
    document.getElementById('bds-help-name').focus();
  }

  function closeModal() {
    modal.style.display = 'none';
  }

  // --- open on button click ---
  btn.addEventListener('click', openModal);

  // Close when clicking the dark overlay (not the card)
  modal.addEventListener('click', function (e) {
    if (e.target === modal) closeModal();
  });

  document.getElementById('bds-help-cancel').addEventListener('click', function (e) {
    e.preventDefault();
    closeModal();
  });

  // --- submit ---
  document.getElementById('bds-help-submit').addEventListener('click', function () {
    var name    = document.getElementById('bds-help-name').value.trim();
    var phone   = document.getElementById('bds-help-phone').value.trim();
    var email   = document.getElementById('bds-help-email').value.trim();
    var message = document.getElementById('bds-help-message').value.trim();
    var errorEl = document.getElementById('bds-help-error');

    if (!name || !phone || !email) {
      errorEl.textContent = 'Please fill in Name, Phone, and Email.';
      errorEl.style.display = 'block';
      return;
    }
    errorEl.style.display = 'none';

    var submitBtn = document.getElementById('bds-help-submit');
    submitBtn.disabled    = true;
    submitBtn.textContent = 'Preparing…';

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // BDS: Cart permalink built from the CURRENT origin so it lands on this store.
        var cartUrl = window.location.origin + '/cart/' + cart.items.map(function (item) {
          return item.variant_id + ':' + item.quantity;
        }).join(',');

        var cartTotal = '$' + (cart.total_price / 100).toFixed(2);

        var lines = [];
        cart.items.forEach(function (item) {
          lines.push('- ' + item.quantity + ' x ' + item.product_title +
                     (item.variant_title && item.variant_title !== 'Default Title'
                        ? ' (' + item.variant_title + ')'
                        : '') +
                     ' [variant ' + item.variant_id + ']');
        });

        var bodyText = [
          'Name: '    + name,
          'Phone: '   + phone,
          'Email: '   + email,
          '',
          'Message:',
          message || '(none)',
          '',
          'Cart total: ' + cartTotal,
          'Cart items:',
          lines.join('\n') || '(empty)',
          '',
          'Cart permalink:',
          cartUrl,
        ].join('\n');

        var mailto = 'mailto:sayitwithswagllc@gmail.com' +
                     '?subject=' + encodeURIComponent('Backdoor Swag — Cart Help Request') +
                     '&body='    + encodeURIComponent(bodyText);

        closeModal();
        var confirmEl = document.getElementById('cart-save-confirm');
        if (confirmEl) confirmEl.style.display = 'block';
        btn.textContent = 'Order Saved ✓';
        btn.disabled    = true;

        window.location.href = mailto;
      })
      .catch(function () {
        submitBtn.disabled    = false;
        submitBtn.textContent = 'Send Help Request';
        errorEl.textContent   = 'Something went wrong — please email sayitwithswagllc@gmail.com for assistance.';
        errorEl.style.display = 'block';
      });
  });
});
